var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoading8(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.3364 63.2315C80.6533 61.0226 80.0678 58.9113 79.3522 56.8648C76.5874 48.8416 71.7408 42.0852 66.6991 35.3937C64.4222 32.3403 62.6006 28.9946 62.6657 24.9992C62.7307 21.8484 63.9342 19.2173 66.2762 17.1384C69.4314 14.3773 73.725 14.9295 76.2621 18.6001C77.921 20.9713 79.0595 23.6999 80.4582 26.2335C85.5324 35.4911 90.5742 44.7812 95.681 54.0063C96.364 55.2082 97.3073 56.3126 98.3482 57.2221C100.495 59.0737 102.804 58.8788 104.268 56.475C106.513 52.8045 108.627 49.004 110.448 45.1061C113.831 37.9598 116.271 30.4563 117.962 22.6929C118.743 19.0873 121.28 18.2103 123.915 20.8414C125.346 22.2706 126.549 24.1871 127.135 26.1361C128.664 31.2359 129.77 36.4656 131.038 41.6304C131.201 42.2476 131.266 42.8647 131.396 43.4819C131.559 43.5794 131.721 43.7093 131.851 43.8067C133.25 42.5074 134.746 41.338 135.982 39.9088C138.617 36.8879 139.918 33.1199 141.447 29.4818C143.171 25.4215 144.83 21.2962 147.009 17.4632C148.831 14.2474 151.596 11.6488 155.271 10.5119C156.963 9.99214 158.849 9.95965 160.671 10.0246C161.159 10.0246 161.939 10.9991 162.069 11.6163C164.379 21.6535 162.948 31.106 157.548 39.9413C155.694 42.9622 153.905 46.0481 152.246 49.1664C151.791 50.0434 151.921 51.2128 151.726 52.6421C154.068 52.0899 156.052 51.6351 158.036 51.1803C159.727 50.7905 161.419 50.4657 163.11 50.0434C164.151 49.7836 164.737 50.2059 165.225 51.0504C167.079 54.2987 166.558 57.417 164.672 60.373C162.59 63.5888 159.305 65.3428 155.889 66.7396C148.278 69.858 140.699 72.9763 132.957 75.7049C124.24 78.7582 115.197 79.6028 105.927 78.8882C95.5509 78.0761 85.1096 77.3615 74.7008 77.1666C68.1953 77.0691 61.6573 78.0111 55.1519 78.4984C51.6064 78.7907 48.1259 78.9207 44.8407 77.1666C41.1 75.1527 39.246 71.4496 40.2868 67.9415C40.9699 65.6027 42.6939 64.3034 44.8081 63.4264C49.1668 61.6398 53.7206 61.9321 58.2745 62.192C65.463 62.5818 72.6516 62.9066 79.8076 63.2639C80.1979 63.3614 80.5883 63.2964 81.3364 63.2315Z",
    fill: "url(#paint0_radial_336_53307)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5259 126.215C66.1439 154.475 81.2041 184.108 95.8739 206.813C104.656 219.417 110.609 226.942 124.986 234.055C143.071 242.761 157.351 221.517 167.434 209.433C182.462 188.027 191.082 163.473 197.717 138.396C203.605 118.744 194.952 93.3422 172.086 91.8479C157.546 89.8015 143.266 95.1937 128.792 93.5695C117.667 92.3027 107.226 87.1704 95.8739 87.6901C76.8129 88.827 65.3632 108.804 65.5259 126.215Z",
    fill: "url(#paint1_linear_336_53307)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.821 92.4541C162.149 94.7444 150.139 103.643 153.21 117.645C162.502 159.972 159.291 170.842 152.116 195.138C151.673 196.637 151.215 198.188 150.744 199.801C147.678 207.221 144.943 213.142 142.696 218.004C138.815 226.407 136.392 231.65 136.242 236.016C147.398 234.332 156.756 222.741 164.193 213.528C165.315 212.138 166.394 210.802 167.428 209.562C182.456 188.156 191.076 163.602 197.711 138.525C203.266 119.983 195.878 96.3242 175.821 92.4541Z",
    fill: "url(#paint2_linear_336_53307)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M118.123 161.103C115.781 161.07 114.382 163.669 115.651 165.618C117.082 167.794 119.522 169.256 122.351 169.289C125.149 169.321 127.653 167.957 129.15 165.813C130.483 163.896 129.117 161.265 126.808 161.233C126.808 161.233 123.587 161.785 122.514 161.752C121.376 161.72 118.123 161.103 118.123 161.103Z",
    fill: "#661A39"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M128.5 172.44C130.842 172.473 132.241 169.874 130.972 167.925C129.541 165.749 127.102 164.287 124.272 164.254C121.474 164.222 118.97 165.586 117.474 167.73C116.14 169.647 117.506 172.278 119.816 172.31L128.5 172.44Z",
    fill: "url(#paint3_linear_336_53307)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M145.514 170.294C148.316 170.294 150.588 166.208 150.588 161.167C150.588 156.126 148.316 152.039 145.514 152.039C142.711 152.039 140.439 156.126 140.439 161.167C140.439 166.208 142.711 170.294 145.514 170.294Z",
    fill: "url(#paint4_radial_336_53307)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M101.275 170.294C104.078 170.294 106.35 166.208 106.35 161.167C106.35 156.126 104.078 152.039 101.275 152.039C98.473 152.039 96.2012 156.126 96.2012 161.167C96.2012 166.208 98.473 170.294 101.275 170.294Z",
    fill: "url(#paint5_radial_336_53307)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M157.645 132.256C158.975 132.256 160.052 130.307 160.052 127.903C160.052 125.5 158.975 123.551 157.645 123.551C156.316 123.551 155.238 125.5 155.238 127.903C155.238 130.307 156.316 132.256 157.645 132.256Z",
    fill: "url(#paint6_linear_336_53307)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M151.237 200.699C152.566 200.699 153.644 198.75 153.644 196.346C153.644 193.942 152.566 191.993 151.237 191.993C149.908 191.993 148.83 193.942 148.83 196.346C148.83 198.75 149.908 200.699 151.237 200.699Z",
    fill: "url(#paint7_linear_336_53307)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M130.647 223.535C131.977 223.535 133.054 221.586 133.054 219.182C133.054 216.778 131.977 214.829 130.647 214.829C129.318 214.829 128.24 216.778 128.24 219.182C128.24 221.586 129.318 223.535 130.647 223.535Z",
    fill: "url(#paint8_linear_336_53307)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M103.649 193.001C104.979 193.001 106.056 191.053 106.056 188.649C106.056 186.245 104.979 184.296 103.649 184.296C102.32 184.296 101.242 186.245 101.242 188.649C101.242 191.053 102.32 193.001 103.649 193.001Z",
    fill: "url(#paint9_linear_336_53307)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8563 133.233C83.1856 133.233 84.2633 131.284 84.2633 128.88C84.2633 126.476 83.1856 124.527 81.8563 124.527C80.5269 124.527 79.4492 126.476 79.4492 128.88C79.4492 131.284 80.5269 133.233 81.8563 133.233Z",
    fill: "url(#paint10_linear_336_53307)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M177.649 168.574C178.979 168.574 180.056 166.625 180.056 164.221C180.056 161.817 178.979 159.868 177.649 159.868C176.32 159.868 175.242 161.817 175.242 164.221C175.242 166.625 176.32 168.574 177.649 168.574Z",
    fill: "url(#paint11_linear_336_53307)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M164.254 92.4551C157.79 96.3985 152.236 99.4717 137.32 103.21C116.851 107.153 93.8672 105.145 93.8672 101.117C93.8672 97.0893 113.351 94.783 136.803 94.783C160.256 94.783 164.905 90.831 164.254 92.4551Z",
    fill: "#F03E2D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M122.289 40.0061C122.289 33.6719 120.793 27.6626 118.126 22.2055C118.093 22.3679 118.028 22.5303 117.995 22.7252C116.304 30.4561 113.864 37.9597 110.482 45.1384C108.628 49.0363 106.546 52.8368 104.301 56.5074C102.838 58.9111 100.528 59.106 98.3814 57.2545C97.3405 56.345 96.3647 55.2405 95.7142 54.0387C90.5748 44.8135 85.5331 35.5235 80.4914 26.2659C79.0927 23.7322 77.9542 21.0036 76.2953 18.6324C73.7582 14.9618 69.4646 14.4096 66.3094 17.1707C63.9349 19.2171 62.7314 21.8807 62.6989 25.0315C62.6013 28.9944 64.4228 32.3402 66.6997 35.3611C71.7415 42.0525 76.5881 48.8089 79.3529 56.8322C80.0685 58.8786 80.654 60.99 81.3371 63.1988C80.5889 63.2638 80.2311 63.3612 79.8408 63.3288C72.6523 62.9714 65.4637 62.6141 58.3077 62.2568C53.7538 62.0294 49.2 61.7046 44.8413 63.4912C42.7271 64.3682 41.0031 65.6675 40.32 68.0063C39.2792 71.5144 41.1332 75.2175 44.8739 77.2314C48.1266 78.9855 51.6396 78.8231 55.1851 78.5632C61.6905 78.0435 68.2285 77.1015 74.734 77.2314C82.4105 77.3613 90.0869 77.7836 97.7634 78.3358C112.466 70.475 122.289 56.2475 122.289 40.0061Z",
    fill: "#3FB830"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_336_53307",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(143.131 85.5557) scale(148.018 147.815)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2083,
    stopColor: "#60C454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5306,
    stopColor: "#91D488"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91D489"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_336_53307",
    x1: 73.0364,
    y1: 90.3021,
    x2: 161.83,
    y2: 229.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8274"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F14432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_336_53307",
    x1: 181.438,
    y1: 76.4046,
    x2: 226.274,
    y2: 124.223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6594A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#F6594A",
    stopOpacity: 0.596718
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F03E2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_336_53307",
    x1: 115.12,
    y1: 151.276,
    x2: 115.247,
    y2: 151.531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F75588"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26161",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_336_53307",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(145.498 161.157) scale(7.39578 7.38564)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2083,
    stopColor: "#76203C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#661A39"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_336_53307",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(101.259 161.157) scale(7.39578 7.38564)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2083,
    stopColor: "#76203C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#661A39"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_336_53307",
    x1: 155.471,
    y1: 167.934,
    x2: 157.438,
    y2: 131.827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2083,
    stopColor: "#EC5266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_336_53307",
    x1: 149.719,
    y1: 224.165,
    x2: 151.686,
    y2: 188.057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2083,
    stopColor: "#EC5266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_336_53307",
    x1: 129.14,
    y1: 246.988,
    x2: 131.107,
    y2: 210.881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2083,
    stopColor: "#EC5266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_336_53307",
    x1: 102.236,
    y1: 214.742,
    x2: 104.203,
    y2: 178.634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2083,
    stopColor: "#EC5266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_336_53307",
    x1: 80.4429,
    y1: 154.973,
    x2: 82.4097,
    y2: 118.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2083,
    stopColor: "#EC5266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_336_53307",
    x1: 175.423,
    y1: 204.919,
    x2: 177.39,
    y2: 168.812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2083,
    stopColor: "#EC5266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading8);
export default __webpack_public_path__ + "static/media/loading_8.69e710bd42ab53f4e90f2894c0bb5147.svg";
export { ForwardRef as ReactComponent };